import React, { PropTypes } from 'react';
import { Divider } from 'material-ui';
import injectSheet from 'react-jss';
import NavLink from '../../nav-link';
import Counter from '../../tc-ui/counter';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

export const styles = {
  connections: {
    paddingTop: '7px',
  },
  title: {
    textTransform: 'uppercase',
    paddingLeft: '16px',
    lineHeight: '48px',
    borderBottom: '1px solid #eee',
  },
  divider: {
    margin: '8px 0 8px 0 !important',
  },
};

class Connections extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { classes: css, values = [] } = this.props;
    const [requests, invitations] = (() => {
      return values.map(value => {
        return {
          value,
          classes: `nav-link connections-widget-link${value === 0 ? ' is-zero' : ''}`,
        };
      });
    })();
    return (
      <div className={css.connections}>
        <div
          className={css.title}
        >
          Partner Requests
        </div>
        <div>
          <NavLink
            routeName="/connections/requests"
            classes={requests.classes}
            // className={classes}
            // {...this.props}
          >
            Received
            <Counter data={requests.value} style={{ backgroundColor: 'red' }} />
          </NavLink>
          <NavLink
            routeName="/connections/invitations"
            classes={invitations.classes}
            // className={classes}
            // {...this.props}
          >
            Sent
            <Counter data={invitations.value} />
          </NavLink>
        </div>
        <Divider />
      </div>
    );
  }
}

Connections.propTypes = {
  classes: PropTypes.object,
  values: PropTypes.array,
  push: PropTypes.func,
};

const select = state => ({
  values: [
    state.connectionsStats.get('pendingRequestCount'),
    state.connectionsStats.get('pendingInviteCount'),
  ],
});

export default connect(select, { push })(injectSheet(styles)(Connections));



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/search-widgets/connections.jsx